// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"176c19cf","239":"a2887406","453":"5a2e9602","455":"0f5100a4"}[chunkId] + ".chunk.js";
};